(function(){
  'use strict';
  document.documentElement.classList.add('meubeltje-v2');
  var header=document.getElementById('hdr_wrap');
  if(header){
    var onScroll=function(){header.classList.toggle('mv2-scrolled',window.scrollY>24);};
    onScroll();window.addEventListener('scroll',onScroll,{passive:true});
  }
  document.querySelectorAll('a[href^="#"]').forEach(function(link){
    link.addEventListener('click',function(e){
      var id=this.getAttribute('href');
      if(id.length<2)return;
      var target=document.querySelector(id);
      if(target){e.preventDefault();target.scrollIntoView({behavior:'smooth',block:'start'});}
    });
  });
})();

// Phase 2: subtle global interaction polish
(function () {
  var ticking = false;
  function updateScrollState() {
    document.body.classList.toggle('mv2-scrolled', window.scrollY > 18);
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) {
      window.requestAnimationFrame(updateScrollState);
      ticking = true;
    }
  }, { passive: true });
  updateScrollState();

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Tab') document.documentElement.classList.add('mv2-keyboard-user');
  });
  document.addEventListener('mousedown', function () {
    document.documentElement.classList.remove('mv2-keyboard-user');
  });
})();
